import Axios from "axios";

export const GetNumFacDevis = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BCDVCLIs?typpe=DV&codep=&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "NUMFAC_DEVIS", payload: response.data });
    });
  };
};
